module.exports = __webpack_public_path__ + "static/img/Tiktok_grid.f76d2a13.png";